export default __webpack_public_path__ + "static/media/transnistria.e14b1f6f.svg";